import React, { useMemo, useState } from "react";
import { Button, Card, Col, Container, Form, FormLabel } from "react-bootstrap";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import Swal from "sweetalert2";
import useUserInformation from "../../../hooks/useUserInformation";
import { handleEnter, postMethod } from "../../../modules/helper";
import Loading from "./Loading";
import style from "./style.module.css";

export default function Login() {
  const { setToken, setStorage, deleteToken } = useUserInformation();

  const showElement = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [isVisible, setIsVisible] = useState(false);

  const setField = (field, value) => {
    setForm({ ...form, [field]: value });
    if (!!errors[field]) setErrors({ ...errors, [field]: null });
  };

  const findFormErrors = () => {
    const { nationalCode, password } = form;

    const newErrors = {};
    if (!nationalCode) {
      newErrors.nationalCode = "کد ملی الزامی است";
    } else if (nationalCode.length > 11 || nationalCode.length < 10) {
      newErrors.nationalCode =
        "کد ملی برای اشخاص حقیقی 10 رقم و برای حقوقی 11 رقم باید باشد";
    }

    if (!password) {
      newErrors.password = "رمز الزامی است";
    }

    return newErrors;
  };

  const sendData = async () => {
    setIsLoading(true);
    const response = await postMethod("/user/v1/loginagent", form);

    if (response && response.status === 200) {
      setToken(response.data.token);
      setStorage(
        {
          agent: response.data.user.agent,
          user: response.data.user,
        },
        true
      );

      window.location.href = "/";
    } else {
      setIsLoading(false);
      Swal.fire({
        title: response?.data?.data ?? "خطای ارتباط با سرور",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const newErrors = findFormErrors();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      sendData();
    }
  };

  useMemo(() => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    deleteToken();
  }, []);

  return (
    <>
      {isLoading && (
        <div className={style.container}>
          <Loading />
        </div>
      )}
      {showElement && !isLoading && (
        <Container>
          <div
            className="d-flex align-items-center justify-content-center text-center"
            style={{ height: "100dvh" }}
          >
            <Col xl={6} lg={6} md={12} xs={12}>
              <img
                src="/images/logo.png"
                alt="img"
                style={{ width: "100%" }}
                className="mb-3"
              />

              <div className="loginFormCol">
                <Card className="w-100">
                  <h2>ورود</h2>
                  <Form className="text-end" onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Label>
                        کد ملی یا شناسه ملی:
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        onKeyDown={e => handleEnter(e)}
                        onChange={e => setField("nationalCode", e.target.value)}
                        isInvalid={!!errors.nationalCode}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.nationalCode}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group style={{ position: "relative" }}>
                      <Form.Label>
                        رمز:<span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type={isVisible ? "text" : "password"}
                        onKeyDown={e => handleEnter(e)}
                        onChange={e => setField("password", e.target.value)}
                        isInvalid={!!errors.password}
                      />
                      <span
                        type="icon"
                        onClick={() => setIsVisible(!isVisible)}
                        style={{
                          position: "absolute",
                          left: "7px",
                          top: "33px",
                        }}
                      >
                        {isVisible ? <EyeFill /> : <EyeSlashFill />}
                      </span>
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mt-2 d-flex">
                      <Form.Check
                        type="checkbox"
                        className="d-inline-block text-dark"
                      ></Form.Check>
                      <FormLabel className="d-inline-block me-3">
                        مرا به خاطر بسپار
                      </FormLabel>
                    </Form.Group>
                    <div className="d-flex">
                      <div className="loginButtonDiv">
                        <Button type="submit" className="loginButton">
                          تائید
                        </Button>
                      </div>
                    </div>
                  </Form>
                </Card>
              </div>
            </Col>
          </div>
        </Container>
      )}
    </>
  );
}
